import React, { useState } from "react";
import HeaderComponent from "@components/common/Header/Header";
import BackIcon from "@styles/all-images/icons/back-button.svg";
import EditIcon from "@styles/all-images/icons/edit.svg";
import ArrowDown from "@styles/all-images/icons/arrow-down.svg";
import SearchIcon from "@styles/all-images/icons/search.svg";
import PlusIcon from "@styles/all-images/icons/plus.svg";
import ArrowLeftIcon from "@styles/all-images/icons/arrow-left.svg";
import ArrowRightIcon from "@styles/all-images/icons/arrow-right.svg";
import DownloadIcon from "@styles/all-images/icons/download.svg";
import ArrowDownIcon from "@styles/all-images/icons/chevron-down.svg";
import ListIcon from "@styles/all-images/icons/list-icon.svg";
import UnarchiveIcon from "@styles/all-images/icons/unarchived.svg";
import EyeIcon from "@styles/all-images/icons/eye-blue.svg";
import { useNavigate } from "react-router-dom";
import StaffAdd from "./StaffAdd";

const StaffManagement = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [isArchiveView, setIsArchiveView] = useState(false);
  const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);

  const handleOpenStaffModal = () => {
    setIsStaffModalOpen(true);
  };

  const handleCloseStaffModal = () => {
    setIsStaffModalOpen(false);
  };

  const handleStaffSubmit = () => {
    setIsStaffModalOpen(false);
  };
  const ProfileManagementData = [
    {
      ProfileId: "1",
      ProfileName: "Profile Name",
      CreatedDate: "02/12/2024",
      ProfileAssignedCount: "6",
      RolesAssigned: ["Role 1", "Role 2", "Role 3", "Role 4"],
      Action: "",
    },
    {
      ProfileId: "2",
      ProfileName: "Profile Name",
      CreatedDate: "02/12/2024",
      ProfileAssignedCount: "6",
      RolesAssigned: ["Role 1", "Role 2", "Role 3", "Role 4"],
      Action: "",
    },
    {
      ProfileId: "3",
      ProfileName: "Profile Name",
      CreatedDate: "02/12/2024",
      ProfileAssignedCount: "6",
      RolesAssigned: ["Role 1", "Role 2", "Role 3", "Role 4"],
      Action: "",
    },
    {
      ProfileId: "4",
      ProfileName: "Profile Name",
      CreatedDate: "02/12/2024",
      ProfileAssignedCount: "6",
      RolesAssigned: ["Role 1", "Role 2", "Role 3", "Role 4"],
      Action: "",
    },
    {
      ProfileId: "5",
      ProfileName: "Profile Name",
      CreatedDate: "02/12/2024",
      ProfileAssignedCount: "6",
      RolesAssigned: ["Role 1", "Role 2", "Role 3", "Role 4"],
      Action: "",
    },
  ];

  const filteredData = ProfileManagementData.filter((ProfileManagement) =>
    Object.values(ProfileManagement).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase()),
    ),
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const [isRightOpen, setIsRightOpen] = useState(false);
  const [selectedRightValue, setRightSelectedValue] = useState("5");

  const righttoggleDropdown = () => {
    setIsRightOpen(!isRightOpen);
  };

  const righthandleOptionClick = (value: string) => {
    setRightSelectedValue(value);
    setIsRightOpen(false);
  };
  return (
    <div>
      <HeaderComponent />

      {/* Sub Header */}
      <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
        <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
          <div className="tw-flex tw-justify-between tw-items-center">
            <div className="tw-flex tw-items-center">
              <a href="/">
                <img src={BackIcon} alt="Back Icon" />
              </a>
              <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                Profile Management
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="tw-p-6 tw-mt-[147px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
          <div className="tw-flex tw-items-center tw-gap-4">
            <div className="tw-relative">
              <input
                type="text"
                placeholder="Search"
                className="tw-pl-10 tw-pr-4 tw-py-2 tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg tw-w-64 tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <img
                src={SearchIcon}
                alt="Search Icon"
                className="tw-absolute tw-left-3 tw-top-2.5 tw-h-5 tw-w-5 tw-text-gray-400"
              />
            </div>
            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-text-sm tw-text-gray-600">Rows per page</span>
              <div className="tw-relative">
                <button
                  className="tw-flex tw-justify-between tw-items-center tw-px-3 tw-py-1 tw-bg-transparent tw-border
                   tw-border-[#E9EAEB] tw-text-[#232323] tw-rounded-lg"
                  onClick={righttoggleDropdown}
                >
                  <div className="tw-flex tw-items-center">
                    <span className="tw-mr-3 tw-font-semibold tw-text-[#535862]">
                      {selectedRightValue}
                    </span>
                  </div>
                  <div>
                    <img
                      src={ArrowDownIcon}
                      alt="Arrow Down Icon"
                      className={`tw-w-4 tw-h-4 tw-transform ${
                        isRightOpen ? "tw-rotate-180" : "tw-rotate-0"
                      }`}
                    />
                  </div>
                </button>

                {isRightOpen && (
                  <div className="tw-absolute tw-right-0 tw-w-auto tw-bg-white tw-rounded-xl tw-shadow-lg tw-border-gray-200 tw-mt-1 tw-p-3">
                    <ul className="tw-py-1">
                      <button
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("1")}
                      >
                        5
                      </button>
                      <button
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("2")}
                      >
                        10
                      </button>
                      <button
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("3")}
                      >
                        15
                      </button>
                      <button
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("4")}
                      >
                        20
                      </button>
                      <button
                        className="tw-w-full tw-text-left tw-px-4 tw-py-2 tw-hover:bg-gray-100 tw-cursor-pointer"
                        onClick={() => righthandleOptionClick("5")}
                      >
                        25
                      </button>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-gap-4">
            {!isArchiveView ? (
              <>
                <button
                  onClick={() => setIsArchiveView(true)}
                  className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-px-4 tw-py-2 primary-custom-button-outline font-primary"
                >
                  <img
                    src={DownloadIcon}
                    alt="Download Icon"
                    className="tw-w-6 tw-h-6"
                  />
                  Archived
                </button>
                <button
                  onClick={handleOpenStaffModal}
                  className="tw-flex tw-items-center tw-gap-2 tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
                >
                  <img
                    src={PlusIcon}
                    alt="Plus Icon"
                    className="tw-w-5 tw-h-5"
                  />
                  Add Profile
                </button>
              </>
            ) : (
              <button
                onClick={() => setIsArchiveView(false)}
                className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-px-4 tw-py-2 primary-custom-button-outline font-primary"
              >
                <img src={ListIcon} alt="Back Icon" className="tw-w-6 tw-h-6" />
                Back to List
              </button>
            )}
          </div>
        </div>

        <div className="tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-shadow tw-overflow-hidden">
          <table className="tw-w-full">
            <thead>
              <tr className="tw-border-b">
                <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862] tw-flex tw-items-center tw-gap-1">
                  Profile ID{" "}
                  <img
                    src={ArrowDown}
                    alt="Arrow Down"
                    className="tw-w-5 tw-h-5"
                  />
                </th>
                <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    Profile Name{" "}
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {!isArchiveView && <span>Created Date</span>}
                    {isArchiveView && <span>Archived Date</span>}
                    <img
                      src={ArrowDown}
                      alt="Arrow Down"
                      className="tw-w-5 tw-h-5"
                    />
                  </div>
                </th>
                {!isArchiveView && (
                  <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                    Profile Assigned Count
                  </th>
                )}
                <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Roles Assigned
                </th>
                <th className="tw-px-6 tw-py-5 tw-text-left tw-text-xs font-weight-medium tw-text-[#535862]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="tw-divide-y tw-divide-gray-200">
              {currentData.map((ProfileManagement, index) => (
                <tr key={index} className="tw-hover:bg-gray-50">
                  <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                    {ProfileManagement.ProfileId}
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                    {ProfileManagement.ProfileName}
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                    {ProfileManagement.CreatedDate}
                  </td>
                  {!isArchiveView && (
                    <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                      <div className="tw-flex tw-items-center tw-gap-5">
                        <span>{ProfileManagement.ProfileAssignedCount}</span>
                        <button
                          onClick={() => navigate("/profile-assigned-users")}
                        >
                          <img
                            src={EyeIcon}
                            alt="Eye Icon"
                            className="tw-w-6 tw-h-6"
                          />
                        </button>
                      </div>
                    </td>
                  )}
                  <td className="tw-px-6 tw-py-4 tw-text-sm font-weight-base font-primary-color">
                    <div className="tw-flex tw-items-center tw-gap-2">
                      {ProfileManagement.RolesAssigned.map((roles, i) => (
                        <span
                          key={i}
                          className="tw-px-2 tw-bg-[#F8FAFC] tw-py-1 tw-border tw-border-[#E9EAEB] tw-rounded-full tw-text-sm tw-text-[#232323]"
                        >
                          {roles}
                        </span>
                      ))}
                      <span className="tw-bg-[#146C94] tw-text-white tw-text-sm tw-font-normal tw-px-2 tw-py-1 tw-rounded-full">
                        +3
                      </span>
                    </div>
                  </td>
                  <td className="tw-px-6 tw-py-4 tw-text-sm">
                    <div className="tw-flex tw-items-center tw-gap-5">
                      {!isArchiveView ? (
                        <>
                          <button onClick={handleOpenStaffModal}>
                            <img
                              src={EditIcon}
                              alt="Edit Icon"
                              className="tw-w-6 tw-h-6"
                            />
                          </button>
                          <button className="tw-text-blue-500">
                            <img
                              src={DownloadIcon}
                              alt="Download Icon"
                              className="tw-w-6 tw-h-6"
                            />
                          </button>
                        </>
                      ) : (
                        <button className="tw-text-blue-500">
                          <img
                            src={UnarchiveIcon}
                            alt="Unarchive Icon"
                            className="tw-w-6 tw-h-6"
                          />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tw-flex tw-justify-between tw-items-center tw-mt-4">
          <div className="tw-text-sm font-gray-color">
            Page {currentPage} of {totalPages}
          </div>
          <div className="tw-flex tw-items-center tw-border tw-border-[#E9EAEB] tw-shadow tw-rounded-lg">
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tl-lg tw-rounded-bl-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <img
                src={ArrowLeftIcon}
                alt="Arrow Left Icon"
                className="tw-w-5 tw-h-5"
              />
              Previous
            </button>
            <span className="tw-bg-[#EDF3F7] tw-px-3 tw-py-1">
              {currentPage}
            </span>
            <button
              className="tw-px-3 tw-py-1 tw-disabled:tw-opacity-50 tw-bg-white tw-rounded-tr-lg tw-rounded-br-lg tw-overflow-hidden tw-text-sm tw-text-[#809199] font-weight-medium tw-flex tw-items-center tw-gap-2"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
              <img
                src={ArrowRightIcon}
                alt="Arrow Right Icon"
                className="tw-w-5 tw-h-5"
              />
            </button>
          </div>
          <div
            className={`tw-fixed tw-top-0 tw-right-0 tw-h-full tw-w-full tw-bg-black/25 tw-shadow-lg tw-transition-transform tw-duration-300 tw-ease-in-out ${
              isStaffModalOpen
                ? "tw-transform tw-translate-x-0"
                : "tw-transform tw-translate-x-full"
            } tw-z-50`}
          >
            {isStaffModalOpen && (
              <StaffAdd
                onClose={handleCloseStaffModal}
                onSubmit={handleStaffSubmit}
                isStaffModalOpen={isStaffModalOpen}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffManagement;
